import { render, staticRenderFns } from "./pedidoDetalle.vue?vue&type=template&id=281256aa&scoped=true&"
import script from "./pedidoDetalle.vue?vue&type=script&lang=js&"
export * from "./pedidoDetalle.vue?vue&type=script&lang=js&"
import style0 from "./pedidoDetalle.vue?vue&type=style&index=0&id=281256aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281256aa",
  null
  
)

export default component.exports